import { Link, useNavigate, useParams } from "react-router-dom";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";
import { indexStore } from "../store/indexStore";
// import { useTranslation } from "react-i18next";
import BranchModel from "../Models/BranchModel";

type HeaderProps = {
  noBack?: boolean;
  backgroundColorfull?: boolean;
  url?: string;

};
export const Header = ({ noBack = false, ...props }: HeaderProps) => {
  // ...
  const {

    branch,
    name,
  } = indexStore();
  // const { t } = useTranslation();

  const navigate = useNavigate();
  const params = useParams();
  return (
    <div className="px-4 pt-4 pb-2">
      <div className="flex items-center justify-between mb-3">
        {/* Back Button */}
        <button
          onClick={() => navigate(`/branches/${params.branch_id}`)}
          className="p-2 rounded-lg cursor-pointer transition-all duration-300 hover:bg-onPrimary/10 active:scale-95 text-onPrimary"
        >
          {localStorage.getItem("Lang") === "ar" ? (
            <FaAngleRight className="w-5 h-5 md:w-6 md:h-6" />
          ) : (
            <FaAngleLeft className="w-5 h-5 md:w-6 md:h-6" />
          )}
        </button>
        <Link to={`/branches/${params.branch_id}`}>
          <h1 className="font-bold text-lg md:text-xl uppercase tracking-wider flex-1 text-center text-onPrimary">
            {branch[name as keyof BranchModel]}
          </h1>
        </Link>
        {/* Spacer for symmetry */}
        <div className="w-9 md:w-10" />
      </div>
    </div>
  );
};
